export const herobts = {
  title: 'Vidderna: live session.',
  subtitle: 'Driven av Kia EV6.',
  image:
    'https://kia-afonso-storage.b-cdn.net/Kia-behind-the-scenes/scen/KIA-BD-Spelning-005.jpg',
  mobileImage:
    'https://kia-afonso-storage.b-cdn.net/Kia-behind-the-scenes/scen/KIA-BD-Spelning-005.jpg',
} as const;

export const twoComponentsTextbts01 = {
  title: 'Mot Vidderna',
  text: 'En låt om svenskt vemod och det eviga sökandet efter ljuset. En toppmodern elbil med möjlighet att dela med sig av batteriets kapacitet via det som kallas för Vehicle-to-Load. Tillsammans skapar de frihetskänsla och längtan efter något storslaget. Skruva upp volymen och lyssna på en exklusiv livespelning av Vidderna, helt driven av el direkt från Kia EV6.',
};

export const twoComponentsTextbts02 = {
  title: 'En oväntad vändning',
  text: 'Det blåste och blev isande kallt längs den skånska kusten. Tack vare en snabbtänkt manager och Kia EV6 som transportmedel kunde Björn Dixgård och Patso Heikinpieti från Mando Diao styra om sina planer. Se vägen fram till spelningen här.',
};

export const kiaImagebts03 = {
  src: 'https://kia-afonso-storage.b-cdn.net/Kia-behind-the-scenes/scen/KIA-BD-Spelning-011.jpg',
  alt: 'Kia behind the scenes',
  sizes: '(max-width: 768px) 100vw, 50vw',
  className: 'mx-auto pt-0 w-full ',
};

export const twoComponentsTextbts03 = {
  title: 'Laddad med Kia EV6',
  text: 'Med Vehicle-to-Load kan EV6 dela med sig upp till 80 % av batteriets kapacitet via ett vanligt 230-voltsuttag, för att förse vad du än önskar med ström. Dessutom ger den oslagbar frihetskänsla med upp till 582 km räckvidd och ultrasnabb laddning, från 10–80 % på ned till 18 minuter.',
};

export const linkbts03 = {
  text: 'Upptäck EV6',
  textSize: '16px',
  url: ' https://www.kia.com/se/nya-bilar/ev6/upptack/',
  className: 'mt-6 mb-6 ',
  openInNewTab: false,
};

export const kiaImagebts04 = {
  src: 'https://kia-afonso-storage.b-cdn.net/kia/KIA-BD-EV6-HERO-B1.jpg',
  alt: 'KIA Bjorn',
  sizes: '(max-width: 768px) 100vw, 50vw',
  className: 'mx-auto pt-0 w-full ',
};

export const twoComponentsTextbts04 = {
  title: 'Björn Dixgård om kreativitet',
  text: 'Som frontman i Mando Diao har Björn Dixgård rört sig från svängig rock till svenskt vemod. Som egen artist kommer inspiration från countryscenen och den storslagna svenska naturen. Möt mannen bakom musiken och hör hur en låt blir till.',
};

export const linkbts04 = {
  text: 'Läs intervjun med Björn Dixgård',
  textSize: '16px',
  url: 'https://story.kia.se/bjorn-dixgard-vidderna-ar-det-eviga-sokandet-efter-ljuset',
  className: 'mt-6 mb-6 ',
  openInNewTab: false,
};

export const subheadingbts = {
  heading: 'Fler bilder från spelningen',
};

export const images = [
  {
    src: 'https://kia-afonso-storage.b-cdn.net/Kia-behind-the-scenes/scen/KIA-BD-Spelning-023.jpg',
    alt: 'Kia behind the scenes',
    sizes: '(max-width: 768px) 100vw, 50vw',
  },
  {
    src: 'https://kia-afonso-storage.b-cdn.net/Kia-behind-the-scenes/scen/KIA-BD-Spelning-007.jpg',
    alt: 'Kia behind the scenes',
    sizes: '(max-width: 768px) 100vw, 50vw',
  },
  {
    src: 'https://kia-afonso-storage.b-cdn.net/Kia-behind-the-scenes/scen/KIA-BD-Spelning-009.jpg',
    alt: 'Kia behind the scenes',
    sizes: '(max-width: 768px) 100vw, 50vw',
  },

  {
    src: 'https://kia-afonso-storage.b-cdn.net/Kia-behind-the-scenes/scen/KIA-BD-Spelning-016.jpg',
    alt: 'Kia behind the scenes',
    sizes: '(max-width: 768px) 100vw, 50vw',
  },

  {
    src: 'https://kia-afonso-storage.b-cdn.net/Kia-behind-the-scenes/scen/KIA-BD-Spelning-024.jpg',
    alt: 'Kia behind the scenes',
    sizes: '(max-width: 768px) 100vw, 50vw',
  },
  {
    src: 'https://kia-afonso-storage.b-cdn.net/Kia-behind-the-scenes/scen/KIA-BD-Spelning-030.jpg',
    alt: 'Kia behind the scenes',
    sizes: '(max-width: 768px) 100vw, 50vw',
  },
];
